import { render, staticRenderFns } from "./ReactivatePositionDialog.vue?vue&type=template&id=09fb0f98"
import script from "./ReactivatePositionDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./ReactivatePositionDialog.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports